/** Import Dependencies */
import React from 'react';

interface IModal {
     handleClose: any;
     background: string;
     class: string;
}

export default class Modal extends React.Component<IModal> {
     state: any = {
          class: 'display-none'
     };

     componentDidMount() {
          setTimeout(() => this.setState({ class: 'display-block' }), 1000);
     }
     public render() {
          return (
               <div id="dr-modal" className={'modal ' + this.state.class}>
                    <section
                         className="modal-main mindy"
                         style={{
                              backgroundImage: 'url(' + this.props.background + ')'
                         }}>
                         <div className="main-header">
                              <span  onClick={this.props.handleClose} className={`${this.props.class} close-btn`}>X</span>
                         </div>
                         {this.props.children}
                    </section>
               </div>
          );
     }
}